import { useSectorMark } from '@hooks/useSectorMarkHook';
import { numFormat } from '@utils/tool';
import dayjs from 'dayjs';

export const use_ANNOUNCEMENTINFORMATION = () => {
  const sectorMark = useSectorMark();
  return [
    { label: '信息标题', value: '', key: 'infoTitle' },
    { label: '客户单位', value: '', key: 'customerCompany' },
    { label: '客户单位联系人', value: '', key: 'tenderOrgContacts' },
    { label: '客户单位联系方式', value: '', key: 'tenderOrgContactsMobile' },
    { label: sectorMark, value: '', key: 'sectorTypeValue' },
    {
      label: '客户单位类型',
      value: '',
      key: 'customerCompanyTypeName',
      render: (record: any) => {
        return record.customerCompanyTypeName
          ? `${record.customerCompanyTypeName}${
              record.customerCompanySecondTypeName ? '/' : ''
            } ${record.customerCompanySecondTypeName || ''}`
          : '';
      }
    },
    { label: '行业', value: '', key: 'industryName' },
    {
      label: '应用方向',
      value: '',
      key: 'applicationDirectionName',
      render: (record: any) => {
        return record.applicationDirectionName
          ? `${record.applicationDirectionName}${
              record.applicationDirectionSecondName ? '/' : ''
            } ${record.applicationDirectionSecondName || ''}`
          : '';
      }
    },
    {
      label: '招标预算（万元）',
      value: '',
      key: 'tenderBudget',
      render: (record: any) => {
        return record.tenderBudget
          ? numFormat(record.tenderBudget) +
              ' ' +
              (record.tenderBudgetCurrencyValue || '')
          : '';
      }
    },
    // { label: '预计采购时间', value: '', key: 'estimatedPurchaseTime' },
    {
      label: '发布时间',
      value: '',
      key: 'publishTime',
      render: (record: any) => {
        return record.publishTime
          ? dayjs(record.publishTime).format('YYYY-MM-DD HH:mm')
          : '';
      }
    },
    {
      label: '开标时间',
      value: '',
      key: 'tenderOpenTime',
      render: (record: any) => {
        return record.tenderOpenTime
          ? dayjs(record.tenderOpenTime).format('YYYY-MM-DD HH:mm')
          : '';
      }
    },
    { label: '招标机构', value: '', key: 'tenderDealer' },
    {
      label: '整包中标金额（万元）',
      value: '',
      key: 'successfulPrice',
      render: (record: any) => {
        return record.successfulPrice
          ? numFormat(record.successfulPrice) +
              ' ' +
              (record.successfulPriceCurrencyValue || '')
          : '';
      }
    },
    {
      label: '整包中标金额备注',
      value: '',
      key: 'successfulPriceRemark',
      montage: 'successfulPriceCurrencyValue'
    },
    {
      label: '省市',
      value: '',
      key: 'provinceName',
      montage: 'provinceName',
      render: (record: any) => {
        return record.provinceName
          ? record.provinceName + ' ' + (record.cityName || '')
          : '';
      }
    }
    // { label: '主要配置', value: '', key: 'majorDispositions' }
  ];
};

export const CURRENCY = ['CNY', 'USD', 'EUR'];
